<template>
  <div class="otherGroup">
    <el-radio-group v-model="radioVal" @change="radioChange">
      <el-radio v-for="(radio, index) in item.options.valueData" :key="index" :label="radio.code" :disabled="item.options.disabled">{{ radio.label }}</el-radio>
    </el-radio-group>
    <template v-if="radioVal == 'other'">
      <div style="margin-top: 10px">
        <el-input v-model="inputVal" @input="inputHandle" :disabled="item.options.disabled"> </el-input>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    item: Object,
  },
  data() {
    return {
      radioVal: "",
      inputVal: "",
    };
  },
  created() {
    console.log(this.$attrs.model[this.item.field]);
    if (this.$attrs.model[this.item.field]) {
      let valArr = this.$attrs.model[this.item.field].split("#");
      this.radioVal = valArr[0] || "";
      this.inputVal = valArr[1] || "";
    }
  },
  methods: {
    radioChange(val) {
      this.$set(this.$attrs.model, this.item.field, val);
    },
    inputHandle(val) {
      if (val.indexOf("#") != -1) {
        this.$message({
          message: "不能含有特殊字符#",
          type: "warning",
        });
      } else {
        this.$set(this.$attrs.model, this.item.field, this.radioVal + "#" + this.inputVal);
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
